<template>
  <transition name="fade">
    <div v-if="toastMessage" class="layer-modal">
      <div class="toast">
        <div class="modal-container">
          <p v-if="isHtmlMessage" v-html="message"></p>
          <p v-else>{{ message }}</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppToast',
  computed: {
    ...mapState(['toastMessage']),
    message () {
      return this.$t(this.toastMessage)
    },
    isHtmlMessage () {
      if (this.toastMessage) {
        return this.message.indexOf('<br>') !== -1
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/AppToast.vue